import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

const onFocus = (field) => {
    field.classList.add("is-focused");
};

const onBlur = (field, input) => {
    if (!input.value.length) {
        field.classList.remove("is-focused");
    }
};

const Field = ({ handle, heading, errors, required }) => (
    <div className={`field form__field form__field--animate js-animated-field${required ? " is-required required" : ""}`}>
        <div htmlFor={heading} className={`input${handle in errors ? " is-invalid" : ""}`}>
            <label htmlFor={`fields-${handle}`} className="form__field__label">{heading}</label>
            <input
                onFocus={(e) => { onFocus(e.target.parentNode.parentNode) }}
                onBlur={(e) => { onBlur(e.target.parentNode.parentNode, e.target) }}
                id={`fields-${handle}`}
                type="text"
                name={`fields[${handle}]`}
            />
        </div>
        {handle in errors
            ? <ul className="form__errors"><li>{errors[handle]}</li></ul>
            : null}
    </div>
);

Field.propTypes = {
    handle: PropTypes.string,
    heading: PropTypes.string,
    errors: PropTypes.object,
    required: PropTypes.bool,
};

const Form = ({ items, onSubmit, errors }) => (
    <div>
        <form
            className="product-enquiry__form"
            method="post"
            acceptCharset="utf-8"
            encType="multipart/form-data"
            onSubmit={onSubmit}
        >
            <input type="hidden" name={window.csrfTokenName} value={window.csrfTokenValue} />
            <input type="hidden" name="handle" value="enquiryForm" />

            {items
                ? <input type="hidden" name="fields[productCode]" value={items} />
                : null}

            <div className="flex-group flex-group--palm-column product-enquiry__flex-group">
                <div className="palm-one-whole one-half">
                    <Field handle="enquirerName" heading="Name" errors={errors} required />
                    <Field handle="email" heading="Email" errors={errors} required />
                    <Field handle="phone" heading="Phone" errors={errors} required />

                    <div className="radio-group">
                        <div className="radio-group__heading">Preferred method of contact</div>
                        <input type="radio" id="fields-contactMethod-phone" name="fields[contactMethod]" value="phone" />
                        <label htmlFor="fields-contactMethod-phone">Phone</label>
                        <input type="radio" id="fields-contactMethod-email" name="fields[contactMethod]" value="email" />
                        <label htmlFor="fields-contactMethod-email">Email</label>
                    </div>
                </div>
                <div className="palm-one-whole one-half">
                    <div className="form__field field field--textarea">
                        <label className="form__field__label" htmlFor="fields[message]">Your message</label>
                        <textarea name="fields[message]" rows="2" />
                    </div>
                    <div className="submit">
                        <div className="form__loader">
                            <svg width="40px" height="40px" viewBox="0 0 128 128">
                                <g>
                                    <circle cx="16" cy="64" r="16" fill="#e6596c" fillOpacity="1" />
                                    <circle cx="16" cy="64" r="14.344" fill="#e6596c" fillOpacity="1" transform="rotate(45 64 64)" />
                                    <circle cx="16" cy="64" r="12.531" fill="#e6596c" fillOpacity="1" transform="rotate(90 64 64)" />
                                    <circle cx="16" cy="64" r="10.75" fill="#e6596c" fillOpacity="1" transform="rotate(135 64 64)" />
                                    <circle cx="16" cy="64" r="10.063" fill="#e6596c" fillOpacity="1" transform="rotate(180 64 64)" />
                                    <circle cx="16" cy="64" r="8.063" fill="#e6596c" fillOpacity="1" transform="rotate(225 64 64)" />
                                    <circle cx="16" cy="64" r="6.438" fill="#e6596c" fillOpacity="1" transform="rotate(270 64 64)" />
                                    <circle cx="16" cy="64" r="5.375" fill="#e6596c" fillOpacity="1" transform="rotate(315 64 64)" />
                                    <animateTransform attributeName="transform" type="rotate" values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64" calcMode="discrete" dur="1120ms" repeatCount="indefinite" />
                                </g>
                            </svg>
                        </div>
                        <input className="btn" type="submit" value="Submit" />
                    </div>
                </div>
            </div>
        </form>
    </div>
);

Form.propTypes = {
    items:    PropTypes.string,
    onSubmit: PropTypes.func,
    errors:   PropTypes.object,
};

const Confirmation = () => (
    <div>
        <h3 className="push--bottom">Thanks for your enquiry</h3>
        <p>We will get back to you shortly</p>
    </div>
);

const Wrapper = ({ items }) => {
    const [errors, setErrors] = useState({});
    const [networkError, setNetworkError] = useState("");
    const [submitted, setSubmitted] = useState(false);

    // onSubmit handler
    const onSubmit = useCallback((event) => {
        event.preventDefault();
        document.querySelector(".form__loader").classList.add("is-submitting");

        if (localStorage.getItem("enquiry-product")) {
            window.dataLayer.push({
                event: "enquiry-submit",
                formName: "product-enquiry",
                numberOfProducts: JSON.parse(localStorage.getItem("enquiry-product")).length,
            });
        }

        fetch("/actions/formie/submissions/submit", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            credentials: "same-origin",
            body: new FormData(event.target),
        }).then((response) => {
            if (!response.ok) {
                setNetworkError("An unexpected error occured, please try again later.");
            }
            return response;
        }).then((response) => response.json())
            .then((json) => {
                if ("errors" in json) {
                    setErrors(json.errors);
                    document.querySelector(".form__loader").classList.remove("is-submitting");
                } else {
                    setSubmitted(true);
                    document.getElementById("multiple-product-enquiry").classList.add("is-submitted");
                    localStorage.removeItem("enquiry-product");
                    document.querySelector(".form__loader").classList.remove("is-submitting");
                }
            });
    }, []);

    return (
        <div>
            {networkError ? <div className="error">{networkError}</div> : null}
            {submitted
                ? <Confirmation />
                : <Form
                    items={items}
                    onSubmit={onSubmit}
                    errors={errors}
                />}
        </div>
    );
};
export default Wrapper;